import angular from 'angular';
import { PopoverService } from './service.tn.popover';

export default angular
    .module('tn.popover', ['tn.utils'])
    // providers
    .service('$tnPopover', PopoverService).name;
